
import { Vue } from "vue-class-component";

export default class Codrej extends Vue {}
